import { DlpRealtimeFooter } from 'components/secondaryMarket/shared/SidePanel/DlpRealtimeFooter';
import { isValid, parseISO } from 'date-fns';
import { useAppSelector } from 'hooks/useAppSelector';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';

type ConnectedDlpRealtimeFooterOwnProps = {
  tabId: string;
  className?: string;
};

export function ConnectedDlpRealtimeFooter({ tabId, className }: ConnectedDlpRealtimeFooterOwnProps) {
  const lastUpdate = useAppSelector(state => liveSelectors.getStreamingLastUpdate(state, tabId));
  const price = useAppSelector(state => liveSelectors.getStreamingUnderlyingPrice(state, tabId));
  const unit = useAppSelector(state => liveSelectors.getStreamingUnderlyingPriceUnit(state, tabId));
  const lastUpdateDate = parseISO(lastUpdate ?? '');
  return (
    <DlpRealtimeFooter
      lastUpdate={isValid(lastUpdateDate) ? lastUpdateDate : null}
      className={className}
      underlyingUnit={unit ?? null}
      underlyingValue={price ?? null}
    />
  );
}
